import React from 'react';
import Flatpickr from 'react-flatpickr';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { TextField, InputAdornment } from '@mui/material';
import { CalendarTodayRounded } from '@mui/icons-material';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import '../theme/flatpickr-dark.css';

// Month picker (flatpickr + its monthSelect plugin) for the Attendance
// module's "select a month" filter. value/onChange are 'YYYY-MM' strings;
// the visible field shows "Aug 2026" (dateFormat below), computed from the
// selected Date object directly rather than trusted string parsing.
export default function MonthField({ label = 'Month', value, onChange, size = 'small', sx }) {
    const dateValue = value ? new Date(`${value}-01T00:00:00`) : undefined;

    return (
        <Flatpickr
            value={dateValue}
            options={{
                plugins: [monthSelectPlugin({ shorthand: true, dateFormat: 'M Y', altFormat: 'M Y' })],
            }}
            onChange={(selectedDates) => {
                const d = selectedDates[0];
                if (!d) return;
                onChange(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
            }}
            render={(props, ref) => (
                <TextField
                    label={label}
                    size={size}
                    sx={sx}
                    inputRef={ref}
                    defaultValue={props.defaultValue}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <CalendarTodayRounded sx={{ color: 'text.secondary', fontSize: 18 }} />
                            </InputAdornment>
                        ),
                    }}
                />
            )}
        />
    );
}
